import React, { useCallback, useEffect, useRef, useState, } from "react";
import AkkhorLayout from '../layout/akkhor';
import { useSelector, useDispatch } from "react-redux";
import { Link } from 'react-router-dom';
import dateFormat from "dateformat";
import { URL_LIST_ALL } from "../configs/api";
import Axios from "axios";
import { actions } from "../redux/authRedux";
import men_teacher from "../assets/img/men-teacher.png"
import girl_teacher from "../assets/img/girl-teacher.png"

import Cropper from "react-easy-crop";
import getCroppedImg from "../component/getCroppedImg";
import { Modal } from "react-bootstrap";
import AnhCCCD from "../component/AnhCCCD";
import { confirmAlert } from "react-confirm-alert";

export default function ProfilePage() {
    const { user } = useSelector((state) => state.auth);
    const [detail, setDetail] = useState(user);
    const [avatar, setAvatar] = useState(user && user.data.avatar);
    const [loadingImage, setLoadingImage] = useState(false)
    const [imageSrc, setImageSrc] = useState(null); // ảnh gốc chọn từ input
    const [crop, setCrop] = useState({ x: 0, y: 0 });
    const [zoom, setZoom] = useState(1);
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
    const [showCropper, setShowCropper] = useState(false);
    const [nameFile, setNameFile] = useState(null);
    const inputRef = useRef(null);
    const dispatch = useDispatch();

    // ---- Bổ sung ảnh CCCD (trang chỉ-xem không có formik) ----
    // AnhCCCD chỉ cần 1 "formik" có values + setFieldValue; tạo adapter tối giản từ state.
    const [anhCCCD, setAnhCCCD] = useState({ cccd_front: "", cccd_back: "" });
    const [moBoSungAnh, setMoBoSungAnh] = useState(false);
    const [luuAnh, setLuuAnh] = useState(false);
    const formikAnh = {
        values: anhCCCD,
        setFieldValue: (name, val) => setAnhCCCD((s) => ({ ...s, [name]: val })),
    };

    // Nạp ảnh CCCD hiện có vào adapter khi mở modal (để hiển thị thumbnail ảnh đã lưu).
    const moModalAnh = () => {
        setAnhCCCD({
            cccd_front: detail.cccd_front || "",
            cccd_back: detail.cccd_back || "",
        });
        setMoBoSungAnh(true);
    };

    const luuAnhCCCD = () => {
        setLuuAnh(true);
        Axios.put(URL_LIST_ALL + "users/" + user.data.id, {
            cccd_front: anhCCCD.cccd_front || "",
            cccd_back: anhCCCD.cccd_back || "",
            code: detail.code,
        }, user.config).then((res) => {
            setLuuAnh(false);
            if (res.data.status === "success") {
                setMoBoSungAnh(false);
                setDetail((d) => ({ ...d, cccd_front: anhCCCD.cccd_front, cccd_back: anhCCCD.cccd_back }));
                confirmAlert({ title: "Thành công", message: "Đã bổ sung ảnh CCCD", buttons: [{ label: "OK" }] });
            } else {
                confirmAlert({ title: "Lỗi", message: res.data.message, buttons: [{ label: "OK" }] });
            }
        }).catch((err) => { setLuuAnh(false); console.log(err); });
    };

    useEffect(() => {
        Axios.get(URL_LIST_ALL + "users/" + user.data.id + "?select_info=1", user.config)
            .then(async (res) => {
                if (res.data.status === "success") {
                    setDetail(res.data.data)
                } else console.log(res.data.message);
            })
            .catch((err) => console.log(err));
    }, [user]);// eslint-disable-line

    useEffect(() => {
        if (avatar && avatar != user.data.avatar) {
            Axios.post(URL_LIST_ALL + 'users_avatar', { user_code: user.data.code, user_id: user.data.id, url: avatar, status: 1 }, user.config).then(res => {
                let newUser = Object.assign({}, user);
                newUser.data.avatar = avatar
                console.log(avatar);
                dispatch(actions.login(newUser));
             
            }).catch(err => console.log(err));
        }
    }, [avatar])

    // Hàm này lưu vùng crop tính theo pixel
    const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
        setCroppedAreaPixels(croppedAreaPixels);
    }, []);

    // Khi người dùng chọn file từ input
    const onFileChange = async (e) => {
        if (e.target.files && e.target.files.length > 0) {
            const file = e.target.files[0];
            const imageDataUrl = await readFile(file);
            setNameFile(file.name);
            
            setImageSrc(imageDataUrl);
            setShowCropper(true);
        }
    };

    // Hàm đọc file thành base64 để hiển thị cropper
    function readFile(file) {
        return new Promise((resolve) => {
            const reader = new FileReader();
            reader.addEventListener("load", () => resolve(reader.result));
            reader.readAsDataURL(file);
        });
    }

    // Hàm crop và upload ảnh
    const onCropConfirm = async () => {
        try {
            const croppedImageBlob = await getCroppedImg(imageSrc, croppedAreaPixels);
            const resizedBlob = croppedImageBlob; // hoặc resize tiếp nếu muốn

            let data = new FormData();
            data.append("type", "s3");
            data.append("name", "file");
            data.append("changename", "1");
            data.append("file", resizedBlob, nameFile); // đổi tên nếu muốn
            data.append("filetype", resizedBlob.type);

            setLoadingImage(true);
            Axios.post(URL_LIST_ALL + "fileupload", data, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: user.config.headers.Authorization,
                },
            })
                .then((res) => {
                    if (res.data.status === "success") {
                        const url = res.data.message;
                        if (url) {
                            setAvatar(url);
                            setLoadingImage(false);
                            setShowCropper(false);
                            setImageSrc(null);
                        }
                    } else {
                        setLoadingImage(false);
                    }
                })
                .catch((err) => {
                    console.log(err);
                    setLoadingImage(false);
                });
        } catch (e) {
            console.error(e);
        }
    };

    return (
        <AkkhorLayout idrole="my-profile">
            <div className="breadcrumbs-area">
                <ul>
                    <li>
                        <Link to="/">Trang chủ</Link>
                    </li>
                    <li>Thông tin cá nhân</li>
                </ul>
            </div>

            {detail && <div className="card height-auto">
                <div className="card-body">

                    <div className="single-info-details">
                        <div className="item-content">
                            <div className="header-inline item-header">
                                <h3 className="text-dark-medium font-medium">{detail.fullname}</h3>
                                <div className="header-elements mt-2">
                                    <ul>
                                        {/* <li><Link to="/update-profile" title="Cập nhật hồ sơ" className='btn btn-sm btn-success'><i className="far fa-edit"></i> Cập nhật hồ sơ</Link></li> */}
                                        {/* <li><Link to="/change-password" title="Thay đổi mật khẩu" className='btn btn-sm btn-info'><i className="fas fa-lock"></i> Thay đổi mật khẩu </Link></li> */}
                                    </ul>
                                </div>
                            </div>
                            <div className="row mt-3">
                                <div className=" col-12 info-table table-responsive">
                                    <h5>Ảnh đại diện:</h5>
                                    <div className="avatar-group mt-3">
                                        <button type="button" className="btn p-0 btn-avatar" onClick={() => inputRef.current.click()}>
                                            {loadingImage ? (
                                                "Đang tải..."
                                            ) : avatar ? (
                                                <img src={avatar} alt="" className="avatar" />
                                            ) : (
                                                <img
                                                    src={(user.data.sex == "Nam" ? men_teacher : girl_teacher)}
                                                    alt=""
                                                    className="avatar"
                                                />
                                            )}
                                            <span className="fas fa-upload upload-icon"></span>
                                        </button>
                                        <input
                                            type="file"
                                            id="file"
                                            ref={inputRef}
                                            style={{ display: "none" }}
                                            accept="image/*"
                                            onChange={onFileChange}
                                        />

                                        {showCropper && (
                                            <>
                                                <div className="cropper-modal">
                                                    <Cropper
                                                        image={imageSrc}
                                                        crop={crop}
                                                        zoom={zoom}
                                                        aspect={1}
                                                        onCropChange={setCrop}
                                                        onZoomChange={setZoom}
                                                        onCropComplete={onCropComplete}
                                                    />

                                                </div>

                                            </>

                                        )}
                                    </div>
                                    {showCropper && <div className="w-100 mt-2">
                                        <button type="button" className="btn btn-sm btn-info" onClick={onCropConfirm}>Lưu</button>
                                        <button type="button" className="btn btn-sm btn-danger ml-2" onClick={() => {
                                            setShowCropper(false);
                                            setImageSrc(null);
                                        }}
                                        >
                                            Hủy
                                        </button>
                                    </div>}
                                </div>
                                <div className="col-12 mb-5"></div>
                                <div className="col-lg-6 info-table table-responsive">
                                    <h5>Thông tin cá nhân:</h5>
                                    <div className="row">

                                        <div className="col-5">Họ và tên:</div>
                                        <div className="col-7 font-medium text-dark-medium">{detail.fullname}</div>

                                        <div className="col-5">Mã số nhân viên:</div>
                                        <div className="col-7 font-medium text-dark-medium">{detail.code}</div>

                                        {detail.company_title &&
                                            <>
                                                <div className="col-5">Công ty:</div>
                                                <div className="col-7 font-medium text-dark-medium">{detail.company_title}</div>
                                            </>
                                        }
                                        {detail.part_title &&
                                            <>
                                                <div className="col-5">Phòng ban:</div>
                                                <div className="col-7 font-medium text-dark-medium">{detail.part_title}</div>
                                            </>
                                        }
                                        {detail.chucvu &&
                                            <>
                                                <div className="col-5">Chức vụ:</div>
                                                <div className="col-7 font-medium text-dark-medium">{detail.chucvu}</div>
                                            </>
                                        }

                                        <div className="col-5">Email:</div>
                                        <div className="col-7 font-medium text-dark-medium">{detail.email}</div>

                                        <div className="col-5">Số điện thoại:</div>
                                        <div className="col-7 font-medium text-dark-medium">{detail.mobile}</div>


                                        <div className="col-5">Ngày gia nhập:</div>
                                        <div className="col-7 font-medium text-dark-medium">{dateFormat(detail.datejoining, 'dd-mm-yyyy')}</div>

                                        <div className="col-5">Giới tính:</div>
                                        <div className="col-7 font-medium text-dark-medium">{detail.sex}</div>

                                        <div className="col-5">Ngày sinh:</div>
                                        <div className="col-7 font-medium text-dark-medium">{dateFormat(detail.birthday, 'dd-mm-yyyy')}</div>

                                        <div className="col-5">Dân tộc:</div>
                                        <div className="col-7 font-medium text-dark-medium">{detail.nation}</div>

                                        <div className="col-5">Địa chỉ liên lạc:</div>
                                        <div className="col-7 font-medium text-dark-medium">{detail.address}</div>

                                    </div>
                                </div>
                                <div className="col-lg-6 info-table table-responsive">
                                    <div className="row">

                                        <div className="col-5">STKNH {detail.bank_name ? detail.bank_name : 'Techcombank'}:</div>
                                        <div className="col-7 font-medium text-dark-medium">{detail.bank_id ? detail.bank_id : "Đang cập nhật"}</div>

                                        <div className="col-5">Số sổ BHXH:</div>
                                        <div className="col-7 font-medium text-dark-medium">{detail.bhxh_id ? detail.bhxh_id : "Đang cập nhật"}</div>

                                        <div className="col-5">MS Thuế:</div>
                                        <div className="col-7 font-medium text-dark-medium">{detail.mst_id ? detail.mst_id : "Đang cập nhật"}</div>

                                        <div className="col-5">Số CCCD/CMND:</div>
                                        <div className="col-7 font-medium text-dark-medium">{detail.cccd ? detail.cccd : "Đang cập nhật"}</div>

                                        <div className="col-5">Ngày cấp CCCD/CMND:</div>
                                        <div className="col-7 font-medium text-dark-medium">{detail.cccd_date ? dateFormat(detail.cccd_date, 'dd-mm-yyyy') : "Đang cập nhật"}</div>

                                        <div className="col-5">Nơi cấp CCCD/CMND:</div>
                                        <div className="col-7 font-medium text-dark-medium">{detail.cccd_address ? detail.cccd_address : "Đang cập nhật"}</div>

                                        <div className="col-5">Ảnh CCCD:</div>
                                        <div className="col-7">
                                            <button type="button" className="btn btn-sm btn-outline-primary" onClick={moModalAnh}>
                                                <span className="fas fa-id-card"></span> Bổ sung ảnh CCCD
                                            </button>
                                        </div>


                                        <div className="col-5">Địa chỉ thường trú:</div>
                                        <div className="col-7 font-medium text-dark-medium">{detail.address_tc ? detail.address_tc : "Đang cập nhật"}</div>


                                        <div className="col-5">Trường đào tạo:</div>
                                        <div className="col-7 font-medium text-dark-medium">{detail.highschool ? detail.highschool : "Đang cập nhật"}</div>

                                        <div className="col-5">Trình độ chuyên môn:</div>
                                        <div className="col-7 font-medium text-dark-medium">{detail.qualification ? detail.qualification : "Đang cập nhật"}</div>

                                        <div className="col-5">Chuyên ngành:</div>
                                        <div className="col-7 font-medium text-dark-medium">{detail.majors ? detail.majors : "Đang cập nhật"}</div>

                                    </div>
                                </div>
                            </div>
                            <div><hr /></div>
                            <div className="row">
                                <h5>Thông tin Hợp đồng:</h5>
                                <div className="col-lg-6 info-table table-responsive">
                                    <div className="row">

                                        <div className="col-5">Thời gian thử việc:</div>
                                        <div className="col-7 font-medium text-dark-medium">{detail.time_test ? detail.time_test : "Đang cập nhật"}</div>

                                        <div className="col-5">Ngày bắt đầu HĐ thử việc:</div>
                                        <div className="col-7 font-medium text-dark-medium">{detail.datehdtv_start ? dateFormat(detail.datehdtv_start, 'dd-mm-yyyy') : "Đang cập nhật"}</div>

                                        <div className="col-5">Ngày kết thúc HĐ thử việc:</div>
                                        <div className="col-7 font-medium text-dark-medium">{detail.datehdtv_end ? dateFormat(detail.datehdtv_end, 'dd-mm-yyyy') : "Đang cập nhật"}</div>

                                        <div className="col-5">Tình trạng hợp đồng:</div>
                                        <div className="col-7 font-medium text-dark-medium">{detail.hd_status ? detail.hd_status : "Đang cập nhật"}</div>

                                    </div>
                                </div>
                                <div className="col-lg-6 info-table table-responsive">
                                    <div className="row">

                                        <div className="col-5">Ngày bắt đầu HĐLĐ lần 1:</div>
                                        <div className="col-7 font-medium text-dark-medium">{detail.datehdld_start_1 ? dateFormat(detail.datehdld_start_1, 'dd-mm-yyyy') : "Đang cập nhật"}</div>

                                        <div className="col-5">Ngày kết thúc HĐLĐ lần 1:</div>
                                        <div className="col-7 font-medium text-dark-medium">{detail.datehdld_end_1 ? dateFormat(detail.datehdld_end_1, 'dd-mm-yyyy') : "Đang cập nhật"}</div>

                                        <div className="col-5">Ngày bắt đầu HĐLĐ lần 2:</div>
                                        <div className="col-7 font-medium text-dark-medium">{detail.datehdld_start_2 ? dateFormat(detail.datehdld_start_2, 'dd-mm-yyyy') : "Đang cập nhật"}</div>

                                        <div className="col-5">Ngày kết thúc HĐLĐ lần 2:</div>
                                        <div className="col-7 font-medium text-dark-medium">{detail.datehdld_end_2 ? dateFormat(detail.datehdld_end_2, 'dd-mm-yyyy') : "Đang cập nhật"}</div>

                                        <div className="col-5">Ngày bắt đầu HĐLĐ lần 3:</div>
                                        <div className="col-7 font-medium text-dark-medium">{detail.datehdld_start_3 ? dateFormat(detail.datehdld_start_3, 'dd-mm-yyyy') : "Đang cập nhật"}</div>

                                        <div className="col-5">Ngày kết thúc HĐLĐ lần 3:</div>
                                        <div className="col-7 font-medium text-dark-medium">{detail.datehdld_end_3 ? dateFormat(detail.datehdld_end_3, 'dd-mm-yyyy') : "Đang cập nhật"}</div>

                                    </div>
                                </div>
                            </div>
                            <div><hr /></div>
                            <div className="row">
                                <h5>Tình trạng hôn nhân:</h5>
                                <div className="col-lg-6 info-table table-responsive">
                                    <div className="row">

                                        <div className="col-5">Tình trạng hôn nhân:</div>
                                        <div className="col-7 font-medium text-dark-medium">{detail.marital_status ? detail.marital_status : "Đang cập nhật"}</div>

                                        {detail.marital_status && detail.marital_status === "Đã kết hôn" &&
                                            <>
                                                <div className="col-5">Họ tên vợ/chồng:</div>
                                                <div className="col-7 font-medium text-dark-medium">{detail.fullname_love ? detail.fullname_love : "Đang cập nhật"}</div>

                                                <div className="col-5">Số điện thoại:</div>
                                                <div className="col-7 font-medium text-dark-medium">{detail.phone_love ? detail.phone_love : "Đang cập nhật"}</div>
                                            </>
                                        }
                                    </div>
                                </div>
                                <div className="col-lg-6 info-table table-responsive">
                                    <div className="row">

                                        {detail.marital_status && detail.marital_status === "Đã kết hôn" &&
                                            <>
                                                <div className="col-5">Tổng số con:</div>
                                                <div className="col-7 font-medium text-dark-medium">{detail.total_child ? detail.total_child : "Đang cập nhật"}</div>
                                                {detail.fullname_child_1 &&
                                                    <>
                                                        <div className="col-5">Họ tên con 1:</div>
                                                        <div className="col-7 font-medium text-dark-medium">{detail.fullname_child_1 ? detail.fullname_child_1 : "Đang cập nhật"}</div>

                                                        <div className="col-5">Ngày sinh con 1:</div>
                                                        <div className="col-7 font-medium text-dark-medium">{detail.birthday_child_1 ? dateFormat(detail.birthday_child_1, 'dd-mm-yyyy') : "Đang cập nhật"}</div>
                                                    </>
                                                }
                                                {detail.fullname_child_2 &&
                                                    <>
                                                        <div className="col-5">Họ tên con 2:</div>
                                                        <div className="col-7 font-medium text-dark-medium">{detail.fullname_child_2 ? detail.fullname_child_2 : "Đang cập nhật"}</div>

                                                        <div className="col-5">Ngày sinh con 2:</div>
                                                        <div className="col-7 font-medium text-dark-medium">{detail.birthday_child_2 ? dateFormat(detail.birthday_child_2, 'dd-mm-yyyy') : "Đang cập nhật"}</div>
                                                    </>
                                                }
                                                {detail.fullname_child_3 &&
                                                    <>
                                                        <div className="col-5">Họ tên con 3:</div>
                                                        <div className="col-7 font-medium text-dark-medium">{detail.fullname_child_3 ? detail.fullname_child_3 : "Đang cập nhật"}</div>

                                                        <div className="col-5">Ngày sinh con 3:</div>
                                                        <div className="col-7 font-medium text-dark-medium">{detail.birthday_child_3 ? dateFormat(detail.birthday_child_3, 'dd-mm-yyyy') : "Đang cập nhật"}</div>
                                                    </>
                                                }
                                            </>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>}

            <Modal show={moBoSungAnh} onHide={() => setMoBoSungAnh(false)} size="lg" centered>
                <Modal.Header closeButton>
                    <Modal.Title className="h6 mb-0">Bổ sung ảnh CCCD</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p className="text-muted mb-2"><small>Chọn ảnh 2 mặt căn cước công dân. Bấm vào ảnh để phóng to.</small></p>
                    <div className="row">
                        <AnhCCCD formik={formikAnh} />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-secondary btn-sm" onClick={() => setMoBoSungAnh(false)}>Đóng</button>
                    <button type="button" className="btn btn-primary btn-sm" onClick={luuAnhCCCD} disabled={luuAnh}>
                        {luuAnh ? "Đang lưu..." : "Lưu ảnh"}
                    </button>
                </Modal.Footer>
            </Modal>
        </AkkhorLayout>
    );
}
